import Vue from 'vue'
import request from '@/helpers/request'
import snack from '@/helpers/snack'
import router from '@/router'

export default {
  GET_GOOD_REMAINS({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.showPreloader) {
        commit('setLoad', true)
      }

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodRemains.all}`,
        {
          params: payload.params,
        },
        true,
      )
        .then(response => {
          const data = response.data.data
          commit('updateGoodRemains', data.items)
          commit('setGoodRemainFilters', data.filters)
          resolve(data.count)
        })
        .catch(() => {
          snack.add(Vue.config.localization.ru.notFoundMessage)
          reject()
        })
        .finally(() => {
          if (payload.showPreloader) {
            commit('setLoad', false)
          }
        })
    })
  },
  GET_GOOD_REMAIN({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.showPreloader) {
        commit('setLoad', true)
      }

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodRemains.one.replace('$1', payload.item)}`,
        {
          params: {
            with: 'good.goodGroup;good.goodBrand;unit;store',
          },
        },
        true,
      )
        .then(response => {
          const item = response.data.data
          commit('setGoodRemain', item)
          resolve()
        })
        .catch(() => {
          snack.add(Vue.config.localization.ru.notFoundMessage)
          reject()
        })
        .finally(() => {
          if (payload.showPreloader) {
            commit('setLoad', false)
          }
        })
    })
  },
  GET_GOOD_REMAIN_HISTORY({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      if (payload.showPreloader) {
        commit('setLoad', true)
      }

      request(
        'GET',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodRemains.history.replace('$1', payload.item)}`,
        {
          params: {
            with: 'flow.type;flow.status;qtyUnit',
            orderBy: 'good_flows|issued_at',
            sortedBy: 'desc',
          },
        },
        true,
      )
        .then(response => {
          const item = response.data.data
          commit('setGoodRemainHistory', item)
          resolve()
        })
        .catch(() => {
          snack.add(Vue.config.localization.ru.notFoundMessage)
          reject()
        })
        .finally(() => {
          if (payload.showPreloader) {
            commit('setLoad', false)
          }
        })
    })
  },
  DELETE_GOOD_REMAIN: ({ commit, dispatch, state }, payload) => {
    return new Promise((resolve, reject) => {
      if (payload.showPreloader) {
        commit('setLoad', true)
      }

      request(
        'DELETE',
        `${Vue.config.server}/${Vue.config.modules.crm.api.goodRemains.one.replace('$1', payload.id)}`,
        {},
        true,
      )
        .then(response => {
          snack.add(Vue.config.localization.ru.successRemove, 'primary')
          commit('removeGoodRemain', payload.id)
          const remainsLength = state.goodRemains.length

          if (remainsLength > 0) {
            const id = state.goodRemains[0].id
            router.push({
              name: 'goodRemainView',
              params: {
                itemId: id,
              },
              hash: router.app.$route.hash,
              query: router.app.$route.query,
            })
            dispatch('GET_GOOD_REMAIN', { item: id })
          } else {
            router.push({ path: Vue.config.modules.crm.route.goodRemains.all })
          }

          resolve()
        })
        .catch(error => {
          snack.add(Vue.config.localization.ru.errorDeletingMessage)
          reject()
        })
        .finally(() => {
          if (payload.showPreloader) {
            commit('setLoad', false)
          }
        })
    })
  },

  async GET_GOOD_REMAIN_WITH_EXTRA({ commit, dispatch }, payload) {
    commit('setLoad', true)
    await Promise.all([dispatch('GET_GOOD_REMAIN', payload), dispatch('GET_GOOD_REMAIN_HISTORY', payload)]).finally(
      () => {
        commit('setLoad', false)
      },
    )
  },
}
